/**
 * React Query hook returning the audit log for a given component id.
 *
 * The config page surfaces the most recent entries in an optional
 * collapsible panel. The backend returns a Laravel paginator envelope
 * but the service already unwraps `data` — the hook stays a one-liner.
 */

import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import {
  componentRulesService,
  type ComponentRuleAuditLogDTO,
} from '../../api/componentRulesService';
import { componentRulesKeys } from './queryKeys';

/** Fetch the audit log for a specific component id. */
export function useComponentRulesAuditLog(
  componentId: string,
): UseQueryResult<ComponentRuleAuditLogDTO[]> {
  return useQuery<ComponentRuleAuditLogDTO[]>({
    queryKey: componentRulesKeys.auditLog(componentId),
    queryFn: () => componentRulesService.listAuditLog(componentId),
    enabled: componentId !== '',
  });
}
